module.exports = __webpack_public_path__ + "static/media/MM62-1MTJ.49ba8844.png";